<template>
  <a-layout-content class="content">
    <a-form ref="ruleForm" :model="form" :label-col="labelCol" :rules="rules" :wrapper-col="wrapperCol"
            style="width: 100%">
      <a-form-item label="页面模版选择" required name="templateId">
        <a-select
          placeholder="Select users"
          v-model:value="form.templateId"
          ref="select"
          @change="templateChange"
        >
          <a-select-option :value="item.id" v-for="item in templates" :key="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="页面预览">
        <a-card hoverable style="width: 480px">
          <template v-slot:cover>
            <img alt="example" :src="currentTemplate.preview"/>
          </template>
          <a-card-meta>
            <template v-slot:description>
              中台基础表单
            </template>
          </a-card-meta>
        </a-card>
      </a-form-item>
      <a-form-item label="页面组件名称" required name="path">
        <a-input :addon-before="addOnBefore" :addon-after="addOnAfter" placeholder="例：form/WeatherBasicForm，vue文件的写入路径"
                 @blur="onBlur"
                 @change="componentNameChange"
                 v-model:value="form.path"/>
      </a-form-item>
      <a-form-item label="路由层级选择" name="choosedRoutes">
        <a-cascader style="width: 100%; text-align: left" v-model:value="form.choosedRoutes" :options="routers"
                    placeholder="选择路由层级，新的路由将插入到这里，建议不超过3层，如不选择即代表与根路由平级"
                    change-on-select @change="onChange"/>
      </a-form-item>
      <a-form-item label="路由路径path" required name="routePath">
        <a-input v-model:value="form.routePath" :maxlength="30" @input="routePathInput"/>
      </a-form-item>
      <a-form-item label="路由名称name" required name="routeName">
        <a-input v-model:value="form.routeName" :maxlength='30'/>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit">
          提交
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          重置
        </a-button>
      </a-form-item>
    </a-form>
  </a-layout-content>
</template>

<script>
export default {
  name: 'PageSelcetor',
  data () {
    return {
      addOnBefore: '@/views/',
      addOnAfter: '.vue',
      routePathInputed: false,
      currentTemplate: {},
      templates: [],
      routers: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        templateId: '',
        path: '',
        routeName: '',
        routePath: '',
        choosedRoutes: [],
      },
      rules: {
        templateId: [
          { required: true, type: 'string', message: '请选择页面模版', trigger: 'change' },
        ],
        path: [
          { required: true, message: '请输入文件路径', trigger: 'blur' },
          {
            type: 'regexp',
            pattern: new RegExp('/^[a-zA-Z]:(((\\\\(?! )[^/:*?<>\\""|\\\\]+)+\\\\?)|(\\\\)?)\\s*$/'),
            required: true,
            message: '文件路径不符合规则',
            trigger: 'blur',
          },
        ],
        routePath: [
          { required: true, message: '请输入路由path路径', trigger: 'blur' },
          { min: 1, max: 30, message: '路由path不超过30个字符（数字、字母、下划线、中划线）', trigger: 'blur' },
          {
            type: 'regexp',
            // 文件夹及扩展名称校验
            pattern: new RegExp('^([a-zA-Z]\\\\:|\\\\\\\\)\\\\\\\\([^\\\\\\\\]+\\\\\\\\)*[^\\\\/:*?"<>|]+\\\\.txt(l)?$'),
            required: true,
            message: '路由路径不符合要求',
            trigger: 'blur',
          },
        ],
        routeName: [
          { required: true, message: '请输入路由name名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度应介于2-30个字符，汉字建议不超过8个', trigger: 'blur' },
        ],
        // choosedRoutes: [
        //   {
        //     type: 'array',
        //     required: true,
        //     message: '请选择即将插入的路由层级',
        //     trigger: 'change'
        //   }
        // ]
      }
    }
  },
  methods: {
    routePathInput () {
      this.routePathInputed = true
    },
    componentNameChange (e) {
      const arr = e.target.value.split('/')
      const newValue = arr[arr.length - 1]
      if (!this.routePathInputed) {
        this.form.routePath = newValue
      }
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    onSubmit () {
      this.$refs.ruleForm
        .validate()
        .then(async () => {
          const form = JSON.parse(JSON.stringify(this.form))
          form.path = this.addOnBefore + form.path + this.addOnAfter
          const res = await this.$api.insertTemplate(form)
          this.$message.success(res.msg)
        })
        .catch(() => {
          this.$message.error('当前文件已存在，或内部错误')
        })
    },
    templateChange (id) {
      console.log(id)
      this.currentTemplate = this.templates.filter(item => item.id === id)[0]
    },
    onBlur (val) {
      console.log(val)
    },
    onChange (val) {
      console.log(val)
    },
    async getTemplates () {
      this.templates = await this.$api.queryBuildInTemplate()
      this.currentTemplate = this.templates[0]
      this.form.templateId = this.currentTemplate.id
    },
    async getRoutrers () {
      this.routers = await this.$api.getRouter()
    }
  },
  components: {},
  created () {
    this.getTemplates()
    this.getRoutrers()
  }
}
</script>

<style lang="scss" scoped>
  ul > li {
    list-style: none;
  }

  .list {
    background: transparent;
    width: 90px;

    ul {
      padding: 0;

      li {
        margin-top: 10px;
        text-align: left;
      }
    }
  }

  .content {
    display: flex;
    flex: 1;
    overflow: auto;
  }
</style>
